import React from 'react';
import styled from 'styled-components';
import { styles, MechanicsAndWorkload as NyyMechanicsAndWorkload } from 'yankees-react-utils';
import { useOktaAuth } from '@okta/okta-react';
import usePlayerSelector from '../../utils/usePlayerSelector';
import { Biomechanics } from '../../data/data';

const StyledWrapper = styled.div`
    margin: -${styles.theme.margin.body};
    height: calc(100% + 2 * ${styles.theme.margin.body});
`;

const MechanicsAndWorkload = () => {
    const { authState } = useOktaAuth();

    const { IsPitcher, PlayerID } = usePlayerSelector();
    const getPitcherDaySummaries = () => Biomechanics.getDaySummariesForPitcher(authState.accessToken, PlayerID);
    const getPitcherDaySummary = (playerId, daySummaryId) => Biomechanics.getDaySummaryForPitcher(authState.accessToken, { playerId, daySummaryId });
    const getPositionPlayerDaySummaries = () => Biomechanics.getDaySummariesForPositionPlayer(authState.accessToken, PlayerID);
    const getPositionPlayerDaySummary = (playerId, daySummaryId) => Biomechanics.getDaySummaryForPositionPlayer(authState.accessToken, { playerId, daySummaryId });

    return (
        <StyledWrapper>
            <NyyMechanicsAndWorkload
                isPitcher={IsPitcher}
                playerId={PlayerID}
                getPitcherDaySummaries={getPitcherDaySummaries}
                getPitcherDaySummary={getPitcherDaySummary}
                getPositionPlayerDaySummaries={getPositionPlayerDaySummaries}
                getPositionPlayerDaySummary={getPositionPlayerDaySummary}
                hideGpsDataLabel
            />
        </StyledWrapper>
    );
};

export default MechanicsAndWorkload;
